export var ToastFix={
    install: function (Vue){
        var toastList = Array();
        var isShow=false;
        Vue.prototype.$toast2=function(message){
            if(message){
                toastList.push(message)
            }
            if(isShow){
                return
            }
            let text = toastList.pop()
            if(!text){
                return;
            }
            isShow=true
            this.$toast({text,callback:()=>{
                    setTimeout(()=>{
                        isShow=false
                        Vue.prototype.$toast2(undefined)
                    },100)
                }})
        }
    }
}
